import React from 'react';
import { Breadcrumb } from 'antd';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styles from './Breadcrumb.module.less';

const BreadcrumbComp = (props) => {

  const { breadcrumbData, extra } = props;

  return (
    <div className={styles.breadcrumb}>
      <Breadcrumb>
        {breadcrumbData.map((itemArray, index) => {

          const [path, name] = itemArray;
          const key = `breadcrumbData_${index}`;
          return (
            <Breadcrumb.Item key={key} className={styles.breadcrumbItem}>
              {path ? <Link to={path}>{name}</Link> : <>{name}</>}
            </Breadcrumb.Item>
          );

        })}
      </Breadcrumb>
      {extra}
    </div>
  );

};

BreadcrumbComp.propTypes = {
  breadcrumbData: PropTypes.arrayOf(PropTypes.array),
  extra: PropTypes.element,
};

BreadcrumbComp.defaultProps = {
  breadcrumbData: [],
  extra: null,
};

export default BreadcrumbComp;
